<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>WHATSAPP API EVOLUTION</h3>
      </div>
      <div class="box-content">
        <p>
          Configure os dados de acesso da api de whats da API EVOLUTION.
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>API URL</label>
              <input class="input" type="text" v-model="newWhats.apiUrl" />
            </div>
            <div class="item flex-1">
              <label>API TOKEN</label>
              <input class="input" type="text" v-model="newWhats.apiToken" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>DEVICE NAME</label>
              <input class="input" type="text" v-model="newWhats.deviceName" />
            </div>
            <div v-if="false" class="item flex-1">
              <label>BEARER TOKEN</label>
              <input class="input" type="text" v-model="newWhats.bearerToken" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="saveSMTP()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
} from "@/services/integration";


export default {
  name: "whatsapp",
  data() {
    return {
      newWhats: {
        apiUrl: '',
        apiToken: '',
        deviceName: '',
        bearerToken: '',
      }
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveSMTP() {
      let data = {
        apiUrl: this.newWhats.apiUrl,
        apiToken: this.newWhats.apiToken,
        deviceName: this.newWhats.deviceName,
        bearerToken: this.newWhats.bearerToken,
      };

      if (!data.apiUrl || !data.apiToken || !data.deviceName || !data.bearerToken) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        whats: data
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.newWhats = result.whats;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },

  },
};
</script>
